// @ts-ignore
import Keycloak, {KeycloakInitOptions} from 'keycloak-js';

import appConfig from "./config";

const keycloak = new Keycloak(appConfig.keycloak)

const keycloakInitConfig: KeycloakInitOptions = {
    onLoad: 'login-required',
    responseMode: 'query',
    checkLoginIframe: true
}

export {keycloak, keycloakInitConfig}
